var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.723 13.9286L12.7701 3.46579C11.7666 1.70151 9.23372 1.70151 8.23015 3.46579L2.27729 13.9286C1.28086 15.6794 2.53943 17.8572 4.54729 17.8572H16.453C18.4609 17.8572 19.7194 15.6794 18.723 13.9286ZM9.78586 6.42794C9.78586 6.03365 10.1059 5.71365 10.5001 5.71365C10.8944 5.71365 11.2144 6.03294 11.2144 6.42794V11.4286C11.2144 11.8229 10.8944 12.1429 10.5001 12.1429C10.1059 12.1429 9.78586 11.8237 9.78586 11.4286V6.42794ZM9.42872 14.6429C9.42872 15.2344 9.90872 15.7144 10.5001 15.7144C11.0916 15.7144 11.5716 15.2344 11.5716 14.6429C11.5716 14.0515 11.0916 13.5715 10.5001 13.5715C9.90872 13.5715 9.42872 14.0515 9.42872 14.6429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.648ff8d95526c2ddf35f469f1614bae4.svg";
export { ForwardRef as ReactComponent };